// const RoundProduct = () => {
//   return (
//     <div
//       className="position-relative"
//       style={{ height: "500px", width: "500px" }}
//     >
//       <div
//         style={{
//           height: "200px",
//           width: "200px",
//           top: "150px",
//           right: "100px",
//         }}
//         className="bg-danger rounded-pill position-absolute"
//       ></div>
//       <div
//         style={{ height: "100px", width: "100px", top: "0", right: "100px" }}
//         className="bg-warning rounded-pill mx-auto position-absolute"
//       ></div>
//     </div>
//   );
// };
// export default RoundProduct;

import React, { useState, useContext } from "react";
import "swiper/scss";
import "swiper/scss/free-mode";
import "./round.scss";
import Countdown from "react-countdown";
import { BsFillStarFill, BsCartPlus } from "react-icons/bs";
import { TiDeleteOutline } from "react-icons/ti";
import MobileCarousel from "../Home/ProductCarousel/MobileCarousel/MobileCarousel.jsx";
import { Helmet } from "react-helmet";
import useWindowSize from "hooks/useWindowSize";
import { addCommas } from "@persian-tools/persian-tools";
import EditProductAdmin from "./EditProductAdmin.jsx";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import CreateComment, { CommentList } from "../SingleProduct/Comments";
import { useEffect } from "react";
import sendRequest from "hooks/useAxios";
import Swal from "sweetalert2";

import { Debounce } from "react-lodash";

import { NavLink } from "react-router-dom";
import toast from "react-hot-toast";
import toastFunction from "utils/toast";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { useParams } from "react-router-dom";
import logo from "assets/images/sitelogo.svg";

const RoundProduct = ({
  productInfo,
  commentList,
  sameProduct,
  maxPrice,
  selectedProduct,
  addCartItem,
  setUpdater,
  productType,
  firstProduct,
  logo,
}) => {
  const auth = useContext(WithAuthentication);
  let bId = useParams();
  const [data, setData] = useState([
    {
      id: 1,
      image: "../assets/asset_1.png",
      title: "شارژر دیواری مدل عروسکی",
      price: 20000000,
      discountprice: "20000000",
      rate: "4",
      countdown: "2022/05/18",
      ratecount: "88",
      sold: 55,
    },
    {
      id: 2,
      image: "../assets/asset_2.png",
      title: "محافظ صفحه نمایش شیشه ای مدل p10",
      price: "550000",
      discountprice: "20000000",
      countdown: "2022/05/18",
      rate: "4",
      ratecount: "88",
      sold: 130,
    },
    {
      id: 3,
      image: "../assets/asset_3.png",
      title: "پایه ضبط صوتی و تصویری موبایل",
      price: "20000000",
      discountprice: "20000000",
      rate: "4",
      countdown: "2022/05/18",
      ratecount: "88",
      sold: 270,
    },
    {
      id: 4,
      image: "../assets/asset_4.png",
      title: "هندزفری بیسیم هواوی",
      price: "20000000",
      discountprice: "20000000",
      countdown: "2022/05/18",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 5,
      image: "../assets/asset_5.png",
      title: "کاور سی جی موبایل مناسب برای گوشی",
      price: "20000000",
      discountprice: "20000000",
      countdown: "2022/05/18",
      rate: "4",
    },
    {
      id: 6,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      rate: "4",
      discountprice: "20000000",
      countdown: "2022/05/18",
      ratecount: "88",
    },
    {
      id: 7,
      image: "../assets/asset_7.png",
      title: "کیت تمیز کننده وندا مدل cleaner new",
      price: "20000000",
      discountprice: "20000000",
      countdown: "2022/05/18",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 8,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      discountprice: "20000000",
      countdown: "2022/05/15",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 9,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      discountprice: "20000000",
      countdown: "2022/05/15",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 10,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      discountprice: "20000000",
      countdown: "2022/05/15",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 11,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      discountprice: "20000000",
      countdown: "2022/05/15",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 12,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      discountprice: "20000000",
      countdown: "2022/05/15",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 13,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 14,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 15,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 16,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 17,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      discountprice: "20000000",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 18,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 19,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 20,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 21,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 22,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 23,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 24,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 25,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 26,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      rate: "4",
      ratecount: "88",
    },
    {
      id: 27,
      image: "../assets/asset_6.png",
      title: "شارز شیائومی 10 اولترا",
      price: "20000000",
      rate: "4",
      ratecount: "88",
    },
  ]);
  const [key, setKey] = useState("detail");
  const products = data;
  // const discountedItems = products?.filter((product) => product.discountprice);
  const [rangeId, setRangeId] = useState(-1);
  // const [selected, setSelected] = useState(discountedItems[0]);
  const [selected, setSelected] = useState(firstProduct);
  const [mainAdmin, setMainAdmin] = useState(false);
  const [productDetail, setProductDetail] = useState({
    business: {},
    product: [
      {
        description: "",
        bodytxt: "",
        url: "",
        title: "",
        rating_count: "",
        avg_rating: "",
      },
    ],
    renge: [
      { to_count: "", from_count: "", to_price: "", from_price: "" },
      { to_count: "", from_count: "", to_price: "", from_price: "" },
      { to_count: "", from_count: "", to_price: "", from_price: "" },
    ],
  });

  const handleItem = (item) => {
    setSelected(item);
  };
  const { width } = useWindowSize();
  // const addCartItem=()=>{
  //   sendRequest("addcartitem",{
  //     product_id:productDetail.id,
  //     SaleConditionId
  //   })
  // }

  const rangeHandler = () => {
    let priceRange;
    for (let i = 0; i < productDetail.renge.length; i++) {
      if (productDetail.renge[i].is_active == "1") {
        priceRange = productDetail.renge[i].from_price;
      }
    }
    return addCommas(priceRange);
  };

  useEffect(() => {
    setProductDetail(productInfo);
    for (let i = 0; i < productDetail.renge.length; i++) {
      if (productDetail.renge[i].is_active == "1") {
        setRangeId(productDetail.renge[i].id);
      }
    }
  }, [productInfo, productDetail]);
  useEffect(() => {
    for (let i = 0; i < auth.userInfo?.bussinesses?.length; i++) {
      if (auth.userInfo?.bussinesses[i]?.type == "0") {
        setMainAdmin(true);
      }
    }
  }, [auth]);
  // console.log("mainshopround", auth);
  // console.log("productInfo xxx", productInfo);
  // console.log("selected", selected);
  // console.log("comlist", commentList);
  // console.log("kkk", id);
  console.log("detail", productDetail);
  // console.log("rangeId", rangeId);
  // console.log("info", productInfo);
  // console.log("discod", discountedItems);
  // console.log("sameProduct", sameProduct);
  // console.log("max", maxPrice);
  // console.log("mainAdmin", mainAdmin);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{productDetail.product[0].title} </title>
        <meta name="title" content={`${productDetail.product[0].title}`} />
        <meta
          name="description"
          content={`${productDetail.product[0].description}`}
        />
        {/* <link rel="shortcut icon" href={`${logo}`} />{" "} */}
        {/* <link rel="canonical" href="http://mysite.com/example" /> */}
      </Helmet>
      {/* <div
        className="title d-flex justify-content-start fs-5 mt-3"
        style={{ borderBottom: "4px solid #f04f31" }}
      >
        <span>شارژر دیواری عروسکی</span>
      </div> */}
      {width > 680 && (
        <div className="" style={{ width: "95%" }}>
          {/* <div className="m-3 d-flex product-button">
            <EditProductAdmin
              productDetail={productDetail}
              maxPrice={maxPrice}
            /> */}
          {/* {auth.isLogged &&
              auth.userInfo.id == productInfo.business[0]?.admin_id && (
                <button
                  className="btn bg-danger mx-1 text-light danger-button"
                  style={{ width: "180px" }}
                  onClick={() => {
                    Swal.fire({
                      title: "آیا از حدف محصول هستید؟",
                      showDenyButton: true,
                      confirmButtonText: "بله",
                      denyButtonText: `خیر`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        sendRequest("deleteproduct", {
                          productId: productInfo.id,
                        }).then((data) => {
                          if (data.status == 1) {
                            toast.success(
                                        <p className="text-center">
            <div>
              <img src={logo} style={{ width: "50px" }} />
            </div>
           
            محصول با موفقیت حذف شد.
          </p>
                              );
                          } else {
                            toast.error(
                                        <p className="text-center">
            <div>
              <img src={logo} style={{ width: "50px" }} />
            </div>
           
            مشکلی در حذف محصول پیش آمده است.
          </p>
                              );
                          }
                        });
                      }
                    });
                  }}
                >
                  <TiDeleteOutline className="me-1" />
                  حذف محصول
                </button>
              )} */}
          {/* </div> */}
          <div className="circle mx-auto">
            <div className=" position-absolute d-flex align-items-center justify-content-center  container-data">
              <div className="info-wrapperd-flex d-flex mx-auto justify-content-center align-items-center flex-column gap-0 gap-md-2 ">
                <div className="d-flex justify-content-between">
                  <div className="carousel-image-wrapper">
                    <img
                      className=" selected-image my-3 me-2"
                      src={`http://marketgroup.tatdemo.ir/${productDetail.product[0].url}`}
                      style={{ width: "200px" }}
                    />
                  </div>

                  <div className="d-flex flex-column justify-content-center mx-4 align-items-center mt-3 text-light countdown-timer">
                    {/* <Countdown date={Date.now() + 5000} /> */}
                    {/* <Countdown date={Date.now() + 5000} /> */}
                    {/* ReactDOM.render( */}

                    {productType == 1 &&
                      Date.now() <
                        productDetail.main_discount_endtime * 1000 && (
                        <Countdown
                          date={productDetail.main_discount_endtime * 1000}
                        />
                      )}
                    {productType == 2 &&
                      Date.now() < productDetail.group_sale_endtime * 1000 && (
                        <Countdown
                          date={productDetail.group_sale_endtime * 1000}
                        />
                      )}
                    {/* {productDetail.renge.length == 0
                    ? Date.now() <
                        productDetail.main_discount_endtime * 1000 && (
                        <Countdown
                          date={productDetail.main_discount_endtime * 1000}
                        />
                      )
                    : Date.now() < productDetail.group_sale_endtime * 1000 && (
                        <Countdown
                          date={productDetail.main_discount_endtime * 1000}
                        />
                      )} */}
                    {/* {Date.now() < productDetail.group_sale_endtime * 1000 && (
                    <Countdown
                      date={
                        productDetail.renge.length == 0
                          ? productDetail.main_discount_endtime * 1000
                          : productDetail.group_sale_endtime
                      }
                    />
                  )}
                  {/* document.getElementById('root') ); */}
                    <div>
                      <div className="d-flex">
                        <div className="d-flex justify-content-end align-items-center gap-1 mt-1 text-light mx-auto">
                          <span
                            className="ratecount"
                            style={{ fontSize: "12px" }}
                          >
                            ({productDetail.product[0].rating_count})
                          </span>
                          <span
                            className="fs-5 rate"
                            style={{ fontSize: "12px" }}
                          >
                            {productDetail.product[0].avg_rating}
                          </span>
                          <i
                            className="score-icon d-flex justify-content-center align-items-center"
                            style={{ fontSize: "12px" }}
                          >
                            <BsFillStarFill color="gold" />
                          </i>
                        </div>
                      </div>

                      {!mainAdmin && productType == 1 && (
                        // (
                        //   (productType == 1 &&
                        //   Date.now() <
                        //     productDetail.main_discount_endtime * 1000) ||
                        //   (productType == 1 &&
                        //     (productDetail.main_discount_endtime == "0" ||
                        //       productDetail.main_discount_endtime == ""))) &&
                        <button
                          className={`selected-button d-flex justify-content-center align-self-center align-items-center mt-1  text-light `}
                          style={{ width: "max-content" }}
                          onClick={() => {
                            // let group = productDetail.renge.length > 0 ? 1 : 0;
                            // let group = productType == 2 ? 1 : 0;
                            let group = productType == 2 ? 1 : 0;

                            // let sale =
                            //   // productDetail.renge.length > 0
                            //   productType == 2 ? rangeId : productDetail.id;
                            addCartItem(
                              productDetail.product_id,
                              productDetail.id,
                              group,
                              productDetail
                            );
                          }}
                        >
                          <BsCartPlus className="mx-1" />
                          افزودن به سبد خرید
                        </button>
                      )}
                      {!mainAdmin &&
                        (rangeId == -1 && productType == 2 ? (
                          // Date.now() > productDetail.group_sale_endtime
                          <p
                            style={{ fontSize: "13px" }}
                            className="text-white border-bottom border-white"
                          >
                            {" "}
                            شرایط فروش گروهی این محصول فعال نیست.
                          </p>
                        ) : Date.now() <
                            productDetail.group_sale_endtime * 1000 &&
                          // ||
                          // productDetail.group_sale_endtime == "0" ||
                          // productDetail.group_sale_endtime == ""
                          productType == 2 ? (
                          <button
                            className={`selected-button d-flex justify-content-center align-self-center align-items-center mt-1  text-light `}
                            style={{ width: "max-content" }}
                            onClick={() => {
                              // let group = productDetail.renge.length > 0 ? 1 : 0;
                              let group = productType == 2 ? 1 : 0;

                              let sale =
                                // productDetail.renge.length > 0
                                productType == 2 ? rangeId : productDetail.id;
                              addCartItem(
                                productDetail.product_id,
                                sale,
                                group,
                                productDetail
                              );
                            }}
                          >
                            <BsCartPlus className="mx-1" />
                            افزودن به سبد خرید
                          </button>
                        ) : (
                          productType == 2 && (
                            <p
                              className="text-white"
                              style={{ fontSize: "12px" }}
                            >
                              زمان فروش گروهی به پایان رسیده است.
                            </p>
                          )
                        ))}
                    </div>
                  </div>
                </div>

                <div className="circle-title text-light d-flex align-items-baseline w-100 two-line mx-auto">
                  <div className="me-3">{productDetail.product[0].title}</div>
                </div>
                <div className="d-flex justify-content-evenly my-2 align-items-baseline price mx-auto">
                  <div className="d-flex justify-content-center align-items-center ">
                    <span className="text-light">قیمت : </span>
                    {productType == 1 && (
                      <span
                        className={`text-secondary text-light px-2  ${
                          // ((productDetail.renge.length == 0 &&
                          //   productDetail.main_discount > 0) ||
                          //   productDetail.renge.length > 0) &&

                          productDetail?.main_discount > 0 &&
                          Date.now() <
                            productDetail.main_discount_endtime * 1000 &&
                          "text-decoration-line-through "
                        }`}
                      >
                        {/* {addCommas(selected.price)} */}
                        {addCommas(productDetail?.main_price)}تومان
                      </span>
                    )}
                    {productType == 2 && (
                      <span
                        className={`text-secondary text-light px-2  ${
                          // ((productDetail.renge.length == 0 &&
                          //   productDetail.main_discount > 0) ||
                          //   productDetail.renge.length > 0) &&
                          productDetail?.renge[0]?.is_active == "0" &&
                          "text-decoration-line-through "
                        }`}
                      >
                        {/* {addCommas(selected.price)} */}
                        {addCommas(productDetail?.renge[0]?.from_price)}تومان
                      </span>
                    )}
                  </div>

                  {
                    // productDetail.renge.length == 0 &&
                    productType == 1 &&
                      productDetail?.main_discount > 0 &&
                      Date.now() <
                        productDetail.main_discount_endtime * 1000 && (
                        <div>
                          <span className="reduced-price fw-bold">
                            {addCommas(
                              productDetail?.main_price -
                                productDetail?.main_discount
                            )}{" "}
                            <span className="reduced-price"> تومان</span>
                            {/* {selected.sold <= 100
                      ? addCommas(selected.price - selected.price * 0.25)
                      : selected.sold <= 200 && selected.sold > 100
                      ? addCommas(selected.price - selected.price * 0.5)
                      : selected.sold > 200 &&
                        addCommas(selected.price - selected.price * 0.5)} */}
                          </span>
                        </div>
                      )
                  }
                  {
                    // productDetail.renge.length > 0
                    productType == 2 &&
                      productDetail?.renge[0]?.is_active == "0" && (
                        <div>
                          <span className="reduced-price fw-bold">
                            {rangeHandler()}
                            {/* {productDetail.renge[0].is_active == "1"
                        ? `${addCommas(productDetail.renge[0].from_price)}تومان`
                        : productDetail.renge[1].is_active == "1"
                        ? `${addCommas(productDetail.renge[1].from_price)}تومان`
                        : productDetail.renge[2].is_active == "1"
                        ? `${addCommas(productDetail.renge[1].from_price)}تومان`
                        : ""} */}
                            {/* {selected.sold <= 100
                      ? addCommas(selected.price - selected.price * 0.25)
                      : selected.sold <= 200 && selected.sold > 100
                      ? addCommas(selected.price - selected.price * 0.5)
                      : selected.sold > 200 &&
                        addCommas(selected.price - selected.price * 0.5)} */}
                          </span>
                          {/* <span className="reduced-price"> تومان</span> */}
                        </div>
                      )
                  }
                </div>
                {
                  // productDetail.renge.length > 0 &&
                  productType == 2 && (
                    <div className="progress-container mx-auto">
                      <div className="loading-container">
                        <div className="d-flex flex-column ">
                          <div className="">
                            {/* first range */}
                            {productDetail.renge.length > 0 &&
                              productType == 2 && (
                                <>
                                  <div
                                    className={`sold-count d-flex justify-content-between align-items-center mt-1  ${
                                      // productDetail.renge[0].saled_count >=
                                      //   productDetail.renge[0].from_count &&
                                      // productDetail.renge[0].saled_count <
                                      //   productDetail.renge[0].to_count
                                      +productDetail.renge[0].saled_count <
                                      +productDetail.renge[0].to_count -
                                        +productDetail.renge[0].from_count +
                                        1
                                        ? "active-progress_active"
                                        : "text-light opacity-50"
                                    }`}
                                  >
                                    <span>
                                      ({productDetail.renge[0].to_count})
                                    </span>
                                    <span>
                                      ({productDetail.renge[0].from_count})
                                    </span>
                                  </div>
                                  <div
                                    dir="ltr"
                                    className="progress my-1 bg-light"
                                  >
                                    <div
                                      dir="ltr"
                                      id="progress-bar"
                                      className="progress-bar"
                                      role="progressbar"
                                      style={{
                                        width: `${
                                          (productDetail.renge[0].saled_count /
                                            productDetail.renge[0].to_count) *
                                          100
                                          // selected.sold <= 100 ? selected.sold : 0
                                        }% `,
                                      }}
                                      aria-valuemin="0"
                                      aria-valuemax="100"
                                    >
                                      {productDetail.renge[0].saled_count}
                                      {/* {selected.sold} */}
                                    </div>
                                  </div>
                                  <div
                                    className={`d-flex  align-items-center 
                    ${
                      // productDetail.renge[0].saled_count >=
                      //   productDetail.renge[0].from_count &&
                      // productDetail.renge[0].saled_count <
                      //   productDetail.renge[0].to_count
                      +productDetail.renge[0].saled_count <
                      +productDetail.renge[0].to_count -
                        +productDetail.renge[0].from_count +
                        1
                        ? "active-progress_price "
                        : "deactive-progress_price"
                    }`}
                                  >
                                    {/* <span>
                                  {" "}
                                  {addCommas(
                                    productDetail.renge[0].to_price
                                  )}{" "}
                                  تومان
                                </span> */}
                                    <span className="mx-auto">
                                      {/* {addCommas(selected.price - selected.price * 0.25)}{" "} */}
                                      {addCommas(
                                        productDetail.renge[0].from_price
                                      )}
                                      تومان
                                    </span>
                                  </div>
                                </>
                              )}
                            {/* second range */}
                            {productDetail.renge.length > 1 &&
                              productType == 2 && (
                                <>
                                  <div
                                    className={`sold-count d-flex justify-content-between align-items-center mt-1  ${
                                      // +productDetail.renge[0].saled_count +
                                      //   +productDetail.renge[1].saled_count >=
                                      //   +productDetail.renge[1].from_count &&
                                      // +productDetail.renge[0].saled_count +
                                      //   +productDetail.renge[1].saled_count <
                                      //   +productDetail.renge[1].to_count
                                      +productDetail.renge[0].saled_count >=
                                        +productDetail.renge[0].to_count -
                                          +productDetail.renge[0].from_count &&
                                      +productDetail.renge[1].saled_count <=
                                        +productDetail.renge[1].to_count -
                                          +productDetail.renge[1].from_count
                                        ? "active-progress_active"
                                        : "text-light opacity-50"
                                    }`}
                                  >
                                    <span>
                                      ({productDetail.renge[1].to_count})
                                    </span>
                                    <span>
                                      ({productDetail.renge[1].from_count})
                                    </span>
                                  </div>
                                  <div
                                    dir="ltr"
                                    className="progress my-1 bg-light"
                                  >
                                    <div
                                      id="progress-bar"
                                      className="progress-bar"
                                      role="progressbar"
                                      style={{
                                        width: `${
                                          // selected.sold < 201 && selected.sold > 100
                                          //   ? String(selected.sold).slice(-2)
                                          //   : 0
                                          (+productDetail.renge[1].saled_count /
                                            (+productDetail.renge[1].to_count -
                                              +productDetail.renge[1]
                                                .from_count +
                                              1)) *
                                          100
                                        }% `,
                                      }}
                                      aria-valuenow="222"
                                      aria-valuemin="101"
                                      aria-valuemax="200"
                                    >
                                      {+productDetail.renge[1].saled_count}
                                      {/* {selected.sold} */}
                                    </div>
                                  </div>
                                  <div
                                    className={`d-flex justify-content-between align-items-center 
                  ${
                    // +productDetail.renge[0].saled_count +
                    //   +productDetail.renge[1].saled_count <
                    //   +productDetail.renge[1].to_count &&
                    // +productDetail.renge[0].saled_count +
                    //   +productDetail.renge[1].saled_count >
                    //   +productDetail.renge[1].to_count
                    +productDetail.renge[0].saled_count >
                      +productDetail.renge[0].to_count -
                        +productDetail.renge[0].from_count &&
                    +productDetail.renge[1].saled_count <
                      +productDetail.renge[1].to_count -
                        +productDetail.renge[1].from_count
                      ? "active-progress_price"
                      : "deactive-progress_price"
                  }`}
                                  >
                                    {/* {addCommas(selected.price - selected.price * 0.25)}{" "} */}
                                    {/* <span>
                                  
                                  {addCommas(productDetail.renge[1].to_price)}{" "}
                                  تومان
                                </span> */}
                                    <span className="mx-auto">
                                      {/* {addCommas(selected.price - selected.price * 0.5)}{" "} */}
                                      {addCommas(
                                        productDetail.renge[1].from_price
                                      )}
                                      تومان
                                    </span>
                                  </div>
                                </>
                              )}
                            {/* third range */}
                            {productDetail.renge.length > 2 &&
                              productType == 2 && (
                                <>
                                  <div
                                    className={`sold-count d-flex justify-content-between align-items-center mt-1 
                        ${
                          // +productDetail.renge[0].saled_count +
                          //   +productDetail.renge[1].saled_count +
                          //   +productDetail.renge[2].saled_count >=
                          //   +productDetail.renge[2].from_count &&
                          // +productDetail.renge[0].saled_count +
                          //   +productDetail.renge[1].saled_count +
                          //   +productDetail.renge[2].saled_count <
                          //   +productDetail.renge[2].to_count
                          +productDetail.renge[1].saled_count >=
                            +productDetail.renge[1].to_count -
                              +productDetail.renge[1].from_count &&
                          +productDetail.renge[2].saled_count <=
                            +productDetail.renge[2].to_count -
                              +productDetail.renge[2].from_count
                            ? "active-progress_active"
                            : "text-light opacity-50"
                        }
                        `}
                                  >
                                    <span>
                                      ({productDetail.renge[2].to_count})
                                    </span>
                                    <span>
                                      ({productDetail.renge[2].from_count})
                                    </span>
                                  </div>
                                  <div
                                    dir="ltr"
                                    className="progress my-1 bg-light"
                                  >
                                    <div
                                      id="progress-bar"
                                      className="progress-bar "
                                      role="progressbar"
                                      style={{
                                        width: `${
                                          (+productDetail.renge[2].saled_count /
                                            (+productDetail.renge[2].to_count -
                                              +productDetail.renge[2]
                                                .from_count +
                                              1)) *
                                          100
                                          // selected.sold > 200
                                          //   ? String(selected.sold).slice(-2)
                                          //   : 0
                                        }%`,
                                      }}
                                      aria-valuemin="201"
                                      aria-valuemax="99999"
                                    >
                                      {+productDetail.renge[2].saled_count}
                                      {/* {selected.sold} */}
                                    </div>
                                  </div>
                                  <div
                                    className={`d-flex justify-content-between align-items-center 
                   ${
                     // selected.sold > 200
                     //   ? "active-progress_price"
                     //   : "deactive-progress_price"
                     +productDetail.renge[1].saled_count >=
                       +productDetail.renge[1].to_count -
                         +productDetail.renge[1].from_count &&
                     +productDetail.renge[2].saled_count <=
                       +productDetail.renge[2].to_count -
                         +productDetail.renge[2].from_count
                       ? "active-progress_price"
                       : "deactive-progress_price"
                   }
                   `}
                                  >
                                    <span className="mx-auto">
                                      {/* {addCommas(selected.price - selected.price * 0.75)}{" "} */}
                                      {addCommas(
                                        productDetail.renge[2].from_price
                                      )}
                                      تومان
                                    </span>
                                  </div>
                                </>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }
              </div>
            </div>

            {/* discountedItems */}
            {sameProduct?.slice(0, 15).map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  handleItem(item);
                  selectedProduct(item.products_id, item.businesses_id);
                }}
                className={`stat ${item.id == selected.id && "selected-item"}`}
                style={{ "--i": index, cursor: "pointer" }}
              >
                {/* <NavLink
                  to={`/product/${item.product_id}/${item.businesses_id}`}
                  className="text-center"
                  target="_blank"
                > */}
                {/* {console.log("item", item, selected)} */}
                {item.img ? (
                  item.img.length > 0 &&
                  item.img[0].url != null && (
                    <img
                      className="circle-image"
                      style={{ borderRadius: "50%" }}
                      // src={item.image}
                      src={`http://marketgroup.tatdemo.ir/${item.img[0].url}`}
                    />
                  )
                ) : (
                  <img
                    className="circle-image"
                    style={{ borderRadius: "50%" }}
                    // src={item.image}
                    src={`http://marketgroup.tatdemo.ir/${item.product[0]?.url}`}
                  />
                )}
                {/* </NavLink> */}
              </div>
            ))}
          </div>
        </div>
      )}
      {width < 681 && (
        <div className="d-flex justify-content-center align-items-center flex-column  mobile-wrapper">
          <MobileCarousel
            // discountedItems={discountedItems}
            firstProduct={firstProduct}
            productDetail={productDetail}
            sameProduct={sameProduct}
            selectedProduct={selectedProduct}
            productType={productType}
            addCartItem={addCartItem}
            mainAdmin={mainAdmin}
          />
        </div>
      )}
      <div className="container detail-tabs">
        {" "}
        <Tabs
          id="detail-tab-product"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >
          <Tab eventKey="detail" title="مشخصات محصول" className="tab">
            <div className="ms-3">
              {productDetail.product[0].description == "" &&
                productDetail.product[0].bodytxt == "" &&
                "در حال حاضر مشخصاتی برای این محصول وجود ندارد."}
              {productDetail.product[0].description != "" && (
                <>
                  <h5>توضیحات:</h5>
                  <p>{productDetail.product[0].description}</p>
                </>
              )}
              {productDetail.product[0].bodytxt != "" && (
                <div className="mt-3">
                  <h5>مشخصات:</h5>
                  <p>{productDetail.product[0].bodytxt}</p>
                </div>
              )}
            </div>
          </Tab>

          <Tab eventKey="comment" title="نظرات " className="tab">
            <CreateComment
              productId={productDetail.product_id}
              businessId={productDetail.businesses_id}
              type="business"
              setUpdater={setUpdater}
            />
            <CommentList commentLists={commentList} setUpdater={setUpdater} />
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default RoundProduct;
